import simpleRestProvider from 'ra-data-simple-rest';
import { API_URL } from '../constants';
import { httpClient } from './httpClient';

const baseDataProvider = simpleRestProvider(API_URL, httpClient);

const uploadFile = async (file: any) => {
  if (file && typeof file === 'object' && file.rawFile instanceof File) {
    const formData = new FormData();
    formData.append('file', file.rawFile);

    const response = await httpClient(`${API_URL}/upload`, {
      method: 'POST',
      body: formData,
    });
    return response.json.url;
  }
  // If it's just a URL string (existing image), return it as is
  // Or if it's an object without rawFile (shouldn't happen with ImageInput + File), return it
  return file;
};

export const dataProvider = {
  ...baseDataProvider,
  create: async (resource: string, params: any) => {
    if ((resource === 'ads' || resource === 'advertiser-accounts') && params.data.imageUrl) {
      const newImageUrl = await uploadFile(params.data.imageUrl);
      return baseDataProvider.create(resource, {
        ...params,
        data: {
          ...params.data,
          imageUrl: newImageUrl,
        },
      });
    }
    return baseDataProvider.create(resource, params);
  },
  update: async (resource: string, params: any) => {
    if ((resource === 'ads' || resource === 'advertiser-accounts') && params.data.imageUrl) {
      const newImageUrl = await uploadFile(params.data.imageUrl);
      return baseDataProvider.update(resource, {
        ...params,
        data: {
          ...params.data,
          imageUrl: newImageUrl,
        },
      });
    }
    return baseDataProvider.update(resource, params);
  },
  customMethod: async (resource: string, params: any, options: any) => {
    const { id, reason } = params;
    const { subPath } = options;

    const url = `${API_URL}/${resource}/${id}/${subPath}`;
    const body = reason ? { reason } : {};

    const response = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    return response.json;
  },
};
